import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../services/login/login.service';

@Component({
    selector: 'app-build',
    templateUrl: './build.page.html',
    styleUrls: ['./build.page.scss'],
    standalone: false,
})
export class BuildPage implements OnInit {
    public cmsPage: boolean = false;
    public searchPage: boolean = false;
    public postPage: boolean = false;
    public homePage: boolean = false;
    public barlowMore = false;
    public hideBanner = false;
    public hideCdnBanner = false;

    private router = inject(Router);
    private route = inject(ActivatedRoute);
    public loginService = inject(LoginService);

    constructor() {
        const data = this.route.snapshot.data['page'];
        if (data === 'cms') this.cmsPage = true;
        if (data === 'search') this.searchPage = true;
        if (data === 'posts') this.postPage = true;
        if (data === 'home') this.homePage = true;

        this.loginService.isAuthenticated.subscribe((value) => {
            if (!this.loginService.isLoggedIn) {
                this.loginService.login(this.router.url);
            }
        });
    }

    ngOnInit(): void {
        this.hideBanner = Boolean(
            sessionStorage.getItem('hideBanner') === 'true',
        );
        this.hideCdnBanner = Boolean(
            sessionStorage.getItem('hideCdnBanner') === 'true',
        );
    }

    hideBarlowBanner() {
        this.hideBanner = true;
        sessionStorage.setItem('hideBanner', 'true');
    }

    hideCdnBannerEvent() {
        this.hideCdnBanner = true;
        sessionStorage.setItem('hideCdnBanner', 'true');
    }
}
